var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.style(200)
  var l0 = _vm.__map(_vm.couponList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var f0 = _vm._f("dateFormat")(item.gmtEnd)
    return {
      $orig: $orig,
      f0: f0,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }